import { Injectable } from "@angular/core";
import { AppConfig } from "../configs/app";
import { CommonService } from "../services/common.service";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(
    public appConfig: AppConfig,
    public commonService: CommonService
  ) {}

  async getProfileInfo() {
    let params = {
      url: this.appConfig.busAPIBaseURL + "user/getProfileInfo",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
      },
    };
    let returnData = await this.commonService.sendHTTPGet(params);

    if (returnData.status == "success") {
      return returnData.data.userData;
    } else {
      let $ = this.commonService.getJQuery();
      $("#commonWarningModal").modal();
      $("#commonWarningModal .modal-body p").html(returnData.message);
      console.log(returnData.message);
      return {};
    }
  }

  async updateProfileInfo(postString: string) {
    let params = {
      url: this.appConfig.busAPIBaseURL + "user/updateProfileInfo",
      data: `${postString}`,
      options: {
        headers: this.commonService.getHTTPBusHeader(),
      },
    };

    return await this.commonService.sendHTTPPost(params);
  }

  async deleteAccount(searchParams: any) {
    let params = {
      url: this.appConfig.busAPIBaseURL + "user/deregister",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: {
          customer_id: searchParams.customerID,
        },
      },
    };

    let returnedData = await this.commonService.sendHTTPPost(params);

    return returnedData;
  }

  async createReceipt(data: any) {
    let postString = this.commonService.objectToString(data);
    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/createReceipt",
      data: `${postString}`,
      options: {
        headers: this.commonService.getHTTPBusHeader(),
      },
    };

    let returnData = await this.commonService.sendHTTPPost(params);

    return returnData;
  }

  async existChecking(data: any) {
    let postString = this.commonService.objectToString(data);
    let params = {
      url: this.appConfig.busAPIBaseURL + "user/existChecking",
      data: `${postString}`,
      options: {
        headers: this.commonService.getHTTPBusHeader(),
      },
    };

    let returnData = await this.commonService.sendHTTPPost(params);

    return returnData.data;
  }

  /* CALLBACK FUNCTION */
  checkAccountDeletable(callback: any) {
    let params = {
      url: this.appConfig.busAPIBaseURL + "user/checkAccountDeletable",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
      },
    };
    this.commonService.sendHTTPGetSync(params, function (res) {
      callback(res.data);
    });
  }

  async checkValidRefundLink(queryParams: any) {
    let returnData = { status: "failed", message: "", data: [] };

    let params = {
      url: this.appConfig.busAPIBaseURL + "payment/combiniRefundAuthChecking",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: queryParams,
      },
    };
    let returnedData = await this.commonService.sendHTTPGet(params);

    if (returnedData.status == "success") {
      returnData.status = returnedData.status;
      returnData.data = returnedData.data;
    }
    returnData.message = returnedData.message;

    return returnData;
  }

  async checkUpdateRefundInfo(postData: any) {
    let returnData = { status: "failed", message: "" };

    let params = {
      url: this.appConfig.busAPIBaseURL + "payment/updateCombiniRefundInfo",
      data: this.commonService.objectToString(postData),
      options: {
        headers: this.commonService.getHTTPBusHeader(),
      },
    };
    let returnedData = await this.commonService.sendHTTPPost(params);

    if (returnedData.status == "success") {
      returnData.status = returnedData.status;
    }
    returnData.message = returnedData.message;

    return returnData;
  }
}
